import React from 'react';

const LinkedInSVG = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-3.5 w-3.5">
    <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
  </svg>
);

const XSVG = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-3.5 w-3.5">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const YouTubeSVG = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-3.5 w-3.5">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

const socialLinks = [
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/synentialabs', icon: LinkedInSVG },
  { name: 'X', href: 'https://x.com', icon: XSVG },
  { name: 'YouTube', href: 'https://www.youtube.com', icon: YouTubeSVG },
];

const capabilities = [
  { name: 'Consulting', href: '/consulting' },
  { name: 'Automation', href: '/automation' },
  { name: 'Agent Development', href: '/agent-development' },
  { name: 'Voice AI', href: '/voice-ai' },
  { name: 'Product Development', href: '/product-development' },
  { name: 'Knowledge & RAG', href: '/knowledge-rag' },
  { name: 'AI Infrastructure', href: '/ai-infrastructure' },
];

const company = [
  { name: 'About', href: '#' },
  { name: 'Lab', href: '/lab' },
  { name: 'Case Studies', href: '/#case-studies' },
  { name: 'Careers', href: '/careers' },
];

const resources = [
  { name: 'Blog', href: '#' },
  { name: 'Documentation', href: '#' },
  { name: 'Security', href: '#' },
  { name: 'Privacy', href: '#' },
];

const NavCol = ({ heading, links }) => (
  <div>
    <h3 className="text-[11px] font-mono text-[--text-muted] uppercase tracking-[0.2em] mb-5">
      {heading}
    </h3>
    <ul className="space-y-3">
      {links.map((link) => (
        <li key={link.name}>
          <a
            href={link.href}
            className="text-sm text-[--text-secondary] hover:text-[--accent] transition-colors"
          >
            {link.name}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

const Footer = () => (
  <footer className="relative bg-[--bg-primary] border-t border-[--border]">
    <div className="max-w-[1500px] mx-auto px-4 sm:px-6">

      {/* Main grid */}
      <div className="py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1fr] gap-10 lg:gap-12">

        {/* Brand + contact */}
        <div className="sm:col-span-2 lg:col-span-1">
          <a href="/" className="inline-block">
            <span className="text-[1.08rem] font-normal text-[--text-primary] tracking-[-0.02em] leading-none">
              synentia
            </span>
          </a>
          <p className="mt-4 text-sm text-[--text-muted] leading-relaxed max-w-xs">
            AI systems that generate revenue, not overhead.
          </p>

          <div className="mt-8 pt-6 border-t border-[--border] space-y-2">
            <p className="text-[11px] font-mono text-[--text-muted] uppercase tracking-[0.2em] mb-4">
              Get in touch
            </p>
            <p className="text-sm text-[--text-secondary]">+1 936 720 7819</p>
            <p className="text-sm text-[--text-secondary]">+91 93443 39155</p>
            <a
              href="mailto:hello@synentialabs.com"
              className="inline-block text-sm text-[--text-secondary] hover:text-[--accent] transition-colors pt-1"
            >
              hello@synentialabs.com
            </a>
          </div>
        </div>

        <NavCol heading="Capabilities" links={capabilities} />
        <NavCol heading="Company" links={company} />
        <NavCol heading="Resources" links={resources} />
      </div>

      {/* Bottom bar */}
      <div className="py-6 border-t border-[--border] flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-[--text-muted] font-mono">
          © 2026 synentia. All rights reserved.
        </p>

        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            {socialLinks.map(({ name, href, icon: Icon }) => (
              <a
                key={name}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={name}
                className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-[--border] bg-[--bg-secondary]/70 text-[--text-secondary] hover:border-[--border-hover] hover:text-[--accent] hover:bg-[--bg-secondary] transition-colors"
              >
                <Icon />
              </a>
            ))}
          </div>

          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-[--text-muted] hover:text-[--text-primary] transition-colors">
              Terms
            </a>
            <a href="#" className="text-xs text-[--text-muted] hover:text-[--text-primary] transition-colors">
              Privacy
            </a>
          </div>
        </div>
      </div>

    </div>
  </footer>
);

export default Footer;
